
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { AppWarning } from '@/components'
import { formatDate } from '@/utils/date'
import AppsApi from '@/api/apps'

@Component({
    components: {
        AppWarning,
    },
})
export default class CommonRenewAppleMembership extends Vue {
    @Prop({ default: null }) private membership?: AppleMembershipEntity

    private status = (this.membership && this.membership.state) || 'none'

    @Watch('membership', { immediate: true, deep: true })
    public watchStatus(
        val: AppleMembershipEntity,
        oldVal: AppleMembershipEntity,
    ) {
        if (val && val.state) {
            this.status = val.state
        }
    }

    get showMembership() {
        return (
            this.membership != null &&
            this.membership.accountId > 0 &&
            (this.membership && this.membership.state) !== 'none' &&
            (this.membership && this.membership.state) !== 'active'
        )
    }

    get expirationDate(): string {
        return (this.membership && this.membership.expirationDate) || ''
    }

    private getText(): string {
        if (this.status === 'pending') {
            return `Renovação pendente, expira em ${formatDate(
                this.expirationDate,
            )}`
        }
        if (this.status === 'overdue') {
            return `Renovação vencida, expirado em ${formatDate(
                this.expirationDate,
            )}`
        }
        return 'Renovação concluída'
    }

    private getType(): string {
        if (this.status === 'pending') {
            return 'warning'
        }
        if (this.status === 'overdue') {
            return 'error'
        }
        return 'success'
    }

    private getShowButton(): boolean {
        return this.status === 'pending' || this.status === 'overdue'
    }

    private renewAppleMembership() {
        this.status = 'active'
        if (this.membership) {
            AppsApi.renewMembership(this.membership.accountId)
        }
    }
}
